import { render } from "./App.vue?vue&type=template&id=6f916f1f&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6f916f1f&lang=css"
import "./App.vue?vue&type=style&index=1&id=6f916f1f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f916f1f"

export default script